/* styles */
import useStyles from './useStyles'
import { Checkbox, IconButton, Tooltip } from '@mui/material'
import ModalMenuItem from '../../Modals/ModalMenu/ModalMenu'
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined'

function TableItem ({ item, suscriber, setLoading }) {
  const classes = useStyles()

  const getIconStatus = (code) => {
    return code === true
      ? (
      <Tooltip title="Activo">
        <IconButton>
          <GppGoodOutlinedIcon className={classes.hoverButton} />
        </IconButton>
      </Tooltip>
        )
      : (
      <Tooltip title={'No Activo'}>
        <IconButton>
          <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
        </IconButton>
      </Tooltip>
        )
  }

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemIcon}>{getIconStatus(item.is_active)}</td>
        <td className={classes.itemName}>
          {item.product?.product_name || '- -'}
        </td>
        <td className={classes.itemCode}>
          {item.product?.product_code || '- -'}
        </td>
        <td className={classes.itemType}>
          {item.product?.product_type?.product_type_name || '- -'}
        </td>
        <td className={classes.itemKebab}>
          <ModalMenuItem
            item={item}
            suscriber={suscriber}
            setLoading={setLoading}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
